import React from 'react';
import styles from './ServiceButton.module.css';

const ServiceButton = ({ icon, label, isActive, onClick }) => {
  return (
    <button 
      className={`${styles.button} ${isActive ? styles.active : ''}`}
      onClick={onClick}
    >
      <img src={icon} alt={label} className={styles.icon} />
      <span className={styles.label}>{label}</span>
    </button>
  );
};

export default ServiceButton;